import React from 'react'

import * as types from './types'

const AlertContext = React.createContext(null)

export const useAlert = () => React.useContext(AlertContext)

const AlertReducer = (state, action) => {
  switch (action.type) {
    case types.OPEN_ALERT:
      return { ...state, isOpen: true }
    case types.CLOSE_ALERT:
      return { ...state, isOpen: false }
    default:
      return { ...state }
  }
}

const initialArg = {
  isOpen: false,
}

type Props = {
  children: React.ReactNode
}

export const AlertProvider = ({ children }: Props) => {
  const [state, dispatch] = React.useReducer(AlertReducer, initialArg)
  return <AlertContext.Provider value={{ state, dispatch }}>{children}</AlertContext.Provider>
}
